import { PelletsChartPoint } from "./Charts";
import { CityPriceModel, PriceInfo, PricePayload } from "./Location";

export const STANDARD_PELLETS_QUANTITY = 6000;

export type PelletProduct = "loose" | "pallet" | "bigbag";

export interface PelletsDealerCard {
  name: string;
  description: string;
  logoUrl: string;
  profileUrl: string;
}

export interface PelletsGuideCard {
  title: string;
  description: string;
  linkText: string;
  link: string;
  image: string;
}

export interface PelletsArticleData {
  title: string;
  contentParagraphs: string[];
  imageSrc: string;
  imageAlt: string;
  imagePosition: "left" | "right";
}

export interface PelletsFaqItem {
  question: string;
  answer: string;
}

export interface InputValues {
  zipCode: string;
  amount: number | string;
}

export interface SupportMessages {
  zipCode: string;
  amount: string;
}

export type PelletProductPriceState = {
  currentPrice: PriceInfo;
  lastPrice: PriceInfo;
  relativeChange: number | string;
};

export type PelletsState = {
  loose: PelletProductPriceState;
  pallet: PelletProductPriceState;
  bigbag: PelletProductPriceState;
};

export type PelletsTopCitiesData = {
  loose: CityPriceModel[];
  pallet: CityPriceModel[];
  bigbag: CityPriceModel[];
};

export type PelletsPayload = {
  loose: PricePayload | null;
  pallet: PricePayload | null;
  bigbag: PricePayload | null;
};

export type PelletsMetrics = {
  currentPrice: number;
  sevenDayAverage: number;
  isPriceHigher: boolean;
};

export type PelletsProductDisplay = {
  price: PelletProductPriceState;
  series: PelletsChartPoint[];
};

export type PelletsDisplay = {
  loose: PelletsProductDisplay;
  pallet: PelletsProductDisplay;
};

export type AverageCityPelletPrices = {
  dates: {
    actual: string | null;
    previous: string | null;
  };
  loose: {
    priceData: CityPriceModel[];
  };
  pallet: {
    priceData: CityPriceModel[];
  };
  bigbag: {
    priceData: CityPriceModel[];
  };
};
